const ROLES = ["P", "D", "C", "A"];

/**
 * Compact per-team cards showing credits, caller badge and high-bidder ring.
 */
export default function ParticipantsHud({ teams, callerId, myId, highBidderId, isSecret, auctionLive }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3" data-testid="participants-hud">
      {teams.map((t) => {
        const isCaller = t.id === callerId;
        const isMe = t.id === myId;
        const isHighBidder = !isSecret && t.id === highBidderId && auctionLive;
        return (
          <div key={t.id}
               className={`glass rounded-xl p-3 ${isCaller ? "border-emerald-400" : ""} ${isHighBidder ? "ring-2 ring-emerald-400" : ""}`}>
            <div className="flex items-center justify-between mb-1">
              <div className="text-xs font-bold text-white truncate">{t.name}{isMe && " (tu)"}</div>
              {isCaller && <span className="text-[9px] uppercase tracking-widest text-emerald-400 font-black">Chiama</span>}
            </div>
            <div className="font-mono font-black text-lg text-emerald-400">
              {t.credits}<span className="text-xs text-slate-500 ml-1">FM</span>
            </div>
            <div className="text-[10px] text-slate-500 mt-1">
              {ROLES.map((r) => `${(t.players || []).filter((p) => p.role === r).length}${r}`).join(" · ")}
            </div>
          </div>
        );
      })}
    </div>
  );
}
